import { Button, ButtonProps } from "react-bootstrap";
import { Spinner } from "../components";
import { ZIconType } from "../helpers/utility/iconMap";
import { ZIcon } from "./ZIcon";

type ZButtonProps = {
    icon?: ZIconType;
    iconSize?: "14px" | "18px" | "24px" | "36px" | "48px";
    buttonText?: string;
    loading?: boolean;
    buttonSize?: "sm" | "md" | "lg"
    children?: React.ReactNode;
}

export const ZButton = ({icon, className, style, onClick, disabled, buttonText, variant, iconSize, loading, buttonSize, ...buttonProps}: ZButtonProps & ButtonProps) => {
    const buttonPadding = (() => {
        switch(buttonSize) {
            case "sm":
                return { x: "0.25rem", y: "0rem" };
            case "md":
                return { x: "0.7rem", y: "0.35rem" };
            case "lg":
                return { x: "0.9rem", y: "0.45rem" };
        }
    })();

    const padding = buttonPadding && {
        paddingTop: buttonPadding.y,
        paddingBottom: buttonPadding.y,
        paddingLeft: buttonPadding.x,
        paddingRight: buttonPadding.x,
    }

    return (
        <Button className={`d-inline-flex align-items-center ${className ?? ""}`} variant={variant ?? "light"} onClick={onClick} disabled={disabled || loading} style={{
            ...padding,
            height: "min-content",
            textWrap: "nowrap",
            ...style
        }} {...buttonProps}>
            {loading ?
                <Spinner className="spinner-border-sm me-1" tag="span" color="white" /> : 
                icon && <ZIcon icon={icon} size={iconSize} iconClassName={`${buttonText ? "me-1" : ""}`}/>
            }
            {buttonText && <p className="mb-0">{buttonText}</p>}
            {buttonProps.children && buttonProps.children}
        </Button>
    );
}